import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';

import { TinySliderComponent } from '../../../ui/addition/tiny-slider/tiny-slider.component';
import { DeprecatedPopUpService } from '../../../ui/controls/pop-up/pop-up.service';

import { AdviceBanner, NewsItem } from './login-main-info.model';
import { LoginMainInfoService } from './login-main-info.service';
import { NewsService } from './login-news.service';

@Component({
	selector: 'app-login-main-info',
	templateUrl: './login-main-info.component.html',
	styleUrls: ['./login-main-info.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class LoginMainInformationComponent implements OnInit {

	@ViewChild(TinySliderComponent)
	public tinySliderComponent: TinySliderComponent;
	public adviceBanners: Array<AdviceBanner>;
	public news: Array<NewsItem>;
	public topTwoNews?: Array<NewsItem>;
	public popupNewsItem: NewsItem | undefined;
	public popupId: string = 'news-popup';

	constructor(
		private loginMainInfoService: LoginMainInfoService,
		private modalService: DeprecatedPopUpService,
		private changeDetectorRef: ChangeDetectorRef,
		private newsService: NewsService,
	) { }

	public ngOnInit(): void {
		this.loginMainInfoService
			.getBanners()
			.subscribe((adviceBanners: Array<AdviceBanner>) => {
				this.adviceBanners = adviceBanners;
				this.changeDetectorRef.markForCheck();
			});

		this.newsService
			.getNews()
			.subscribe((news: Array<NewsItem>) => {
				this.news = news;
				this.topTwoNews = news.slice(0, 2);
				this.changeDetectorRef.markForCheck();
			});
	}

	public showAllNews(): void {
		this.popupNewsItem = undefined;
	}

	public chooseNewsItem(item: NewsItem): void {
		this.popupNewsItem = item;
	}

	public openPopup(item: NewsItem): void {
		this.chooseNewsItem(item);
		this.modalService.open(this.popupId);
	}

	public closePopup(): void {
		this.modalService.close(this.popupId);
	}

	public slideToNextAdvice(index: number): void {
		const lastAdviceBannerIndex: number = this.adviceBanners.length - 1;

		if (index !== lastAdviceBannerIndex) {
			this.tinySliderComponent.slider?.goTo('next');
		} else {
			this.tinySliderComponent.slider?.goTo('first');
		}
	}
}
